import convertArrayToCsv from 'convert-array-to-csv'
import { Track } from '../../classes/track'
import { IColumnHeader } from '../../constants'

export function tracksToCsv(tracks: Track[], columns: IColumnHeader[]): string {
  const dataArrays: any[][] = []

  for (const track of tracks) {
    const d: any[] = []

    for (const col of columns.filter(x => x.visible)) {
      let val: string | null | undefined = (track as any)[col.value]

      if (val === null || val === undefined) val = ''

      d.push(val.toString())
    }

    dataArrays.push(d)
  }

  return convertArrayToCsv(dataArrays, {
    header: columns.filter(x => x.visible).map(x => x.label)
  })
}
